<template>
  <div class="h-100">
    <b-row class="complementaryDiagnosisView">
      <b-col
        xl="2"
        lg="2"
        class="p-0 h-100"
        :class="[showSample ? 'sample-col' : 'sample-compact-col', !showSample]"
      >
        <b-card class="sample-content component-bg">
          <div class="sample-section">
            <complementaries-cards
              ref="complementaryCards"
              :lab-id="labId"
              :cas-id="casId"
              :show-compact-view="!showSample"
              :complementary-id="complementarySelected ? complementarySelected.comId : null"
              class="mx-2"
              @cardSelected="onCardSelected"
              @updateCase="$emit('updateCase')"
              @show-complementary-attachment-tree-modal="$emit('show-complementary-attachment-tree-modal', $event)"
              @reloadSummary="getSectionsSummary"
            />
          </div>
          <div
            slot="footer"
            class="d-flex justify-content-end"
          >
            <b-button
              v-if="showSample"
              qa="complementaries-diagnosis-complementaries-compact-button"
              class="btn__icon btn__icon--primary px-2"
              @click="showSample=!showSample"
            >
              <i
                class="far fa-chevron-left"
                aria-hidden="true"
              />
            </b-button>
            <b-button
              v-else
              qa="complementaries-diagnosis-complementaries-expand-button"
              class="btn__icon btn__icon--primary px-2"
              @click="showSample=!showSample"
            >
              <i
                class="far fa-chevron-right"
                aria-hidden="true"
              />
            </b-button>
          </div>
        </b-card>
      </b-col>
      <b-col class="data-col h-100">
        <b-card class="section-col component-bg">
          <div class="section-col_container">
            <b-row class="section-col_row h-100">
              <b-col
                v-if="complementarySelected"
                class="diagnosis-content comps h-100"
              >
                <b-tabs
                  :key="complementarySelected ? complementarySelected.comId : null"
                  v-model="tabIndexSelected"
                  pills
                  card
                  vertical
                  class="vt-tabs--vertical h-100"
                  content-class="h-100"
                >
                  <b-tab title-item-class="manuallyControlledTab">
                    <template slot="title">
                      <i
                        qa="complementaries-diagnosis-complementary-information-i"
                        class="section-icon fas fa-info"
                        aria-hidden="true"
                      />
                      <div
                        v-if="sectionsSummary && sectionsSummary.hasBasicData"
                        class="section-bubble"
                      />
                    </template>
                    <div
                      v-shortkey="['ctrl', '1']"
                      class="py-2 section-content"
                      @shortkey.prevent="tabIndexSelected = COMPLEMENTARIES_TAB_INDEX"
                    >
                      <section-complementaries
                        v-if="tabIndexSelected===COMPLEMENTARIES_TAB_INDEX"
                        ref="complementarySection"
                        :lab-id="labId"
                        :cas-id="casId"
                        :is-case-in-amendment="isCaseInAmendment"
                        :complementary-id="complementarySelected ? complementarySelected.comId : null"
                        @loadComplementaries="$refs.complementaryCards.loadComplementaries($event)"
                        @reloadSummary="getSectionsSummary"
                        @updateCase="$emit('updateCase')"
                      />
                    </div>
                  </b-tab>
                  <b-tab title-item-class="manuallyControlledTab">
                    <template slot="title">
                      <i
                        qa="complementaries-diagnosis-codifications-i"
                        class="section-icon fal fa-project-diagram"
                        aria-hidden="true"
                      />
                      <div
                        v-if="sectionsSummary && sectionsSummary.hasCodifications"
                        class="section-bubble"
                      />
                    </template>
                    <div
                      v-shortkey="['ctrl', '2']"
                      class="py-2 section-content-grid"
                      @shortkey.prevent="tabIndexSelected = CODIFICATIONS_TAB_INDEX"
                    >
                      <section-codifications
                        v-if="tabIndexSelected===CODIFICATIONS_TAB_INDEX"
                        ref="codificationsSection"
                        :disabled="!!complementarySelected.validationDate"
                        :parent-entity-ids-array="[labId, casId, complementarySelected ? complementarySelected.comId : null]"
                        :codifications-service="complementaryCodificationsServices"
                        :can-edit-codifications="$_canEditComplementary()"
                        @reloadSummary="getSectionsSummary"
                      />
                    </div>
                  </b-tab>
                  <b-tab title-item-class="manuallyControlledTab">
                    <template slot="title">
                      <i
                        qa="complementaries-diagnosis-observations-i"
                        class="section-icon fal fa-eye"
                        aria-hidden="true"
                      />
                      <div
                        v-if="sectionsSummary && sectionsSummary.hasObservations"
                        class="section-bubble"
                      />
                    </template>
                    <div
                      v-shortkey="['ctrl', '3']"
                      class="p-2 h-100"
                      @shortkey.prevent="tabIndexSelected = OBSERVATIONS_TAB_INDEX"
                    >
                      <section-complementary-observations
                        v-if="tabIndexSelected===OBSERVATIONS_TAB_INDEX"
                        ref="observationsSection"
                        :lab-id="labId"
                        :cas-id="casId"
                        :complementary-id="complementarySelected ? complementarySelected.comId : null"
                        @reloadSummary="getSectionsSummary"
                      />
                    </div>
                  </b-tab>
                </b-tabs>
              </b-col>
              <b-col v-if="!complementarySelected">
                <div
                  class="d-flex"
                  style="width: 100%; height: calc(100vh - 270px); margin-top: 15px;"
                >
                  <div class="d-flex comp-empty-state">
                    <div class="empty-col">
                      <div
                        class="empty-section"
                        style="opacity: .07"
                      />
                      <div
                        class="empty-section mt-1"
                        style="opacity: .07"
                      />
                    </div>
                    <div class="w-100">
                      <div class="p-3 d-flex flex-fill justify-content-between">
                        <div class="empty-box title" />
                        <div class="d-flex">
                          <div class="empty-box button mx-2" />
                          <div class="empty-box button mx-2" />
                          <div class="empty-box button ml-2" />
                        </div>
                      </div>
                      <div class="empty-state-layout d-flex flex-column justify-content-center">
                        <b-container class="d-flex align-items-center justify-content-center">
                          <div class="d-flex align-items-center flex-column">
                            <div class="d-flex align-items-center justify-content-center picture">
                              <img
                                src="@/img/comp-empty-state.png"
                                alt="complementary empty state"
                              >
                              <div class="circle" />
                            </div>
                            <h3 class="dark mt-4">
                              {{ $t('diagnosis.complementaries.emptyStateTitle') }}
                            </h3>
                            <span>{{ $t('diagnosis.complementaries.emptyStateSubtitle') }}</span>
                          </div>
                        </b-container>
                      </div>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <modal-unsaved-changes
      id="ComplementariesDiagnosisUnsavedChangesModal"
      ref="unsavedChangesModal"
    />
  </div>
</template>

<script>
import ComplementariesCards from '@/modules/diagnosisModule/views/form/complementariesView/ComplementariesCards'
import SectionComplementaries from '@/modules/diagnosisModule/views/form/complementariesView/SectionComplementaries'
import SectionCodifications from '@/modules/diagnosisModule/views/form/sections/SectionCodifications'
import SectionComplementaryObservations from '@/modules/diagnosisModule/views/form/complementariesView/SectionComplementaryObservations'
import complementaryCodificationsServices from '@/api/resources/complementaries/complementaryCodificationsServices'
import ModalUnsavedChanges from '@/components/modals/ModalUnsavedChanges'
import commonComplementaryService from '@/api/resources/common/commonComplementaryService'
import { ComplementaryOperationGuardMixin } from '@/api/operations/mixins/guards/complementary-operation-guard.mixin'
import { router } from '@/router'
import { HelperUtils } from '@/shared/util/helper-utils'

const COMPLEMENTARIES_TAB_INDEX = 0
const CODIFICATIONS_TAB_INDEX = 1
const OBSERVATIONS_TAB_INDEX = 2
export default {
    name: 'ComplementariesDiagnosis',
    components: {
        ComplementariesCards,
        SectionComplementaries,
        SectionCodifications,
        SectionComplementaryObservations,
        ModalUnsavedChanges
    },
    mixins: [
        ComplementaryOperationGuardMixin
    ],
    props: {
        labId: { type: Number, required: true },
        casId: { type: Number, required: true },
        isCaseInAmendment: { type: Boolean, default: false }
    },
    data() {
        return {
            complementarySelected: null,
            tabIndexSelected: COMPLEMENTARIES_TAB_INDEX,
            showSample: true,
            complementariesSummary: null,
            sectionsSummary: null,
            complementariesSections: [
                { content: 'complementaries', icon: 'fal fa-file-import' },
                { content: 'codifications', icon: 'fal fa-project-diagram' },
                { content: 'observations', icon: 'fal fa-eye' }
            ]
        }
    },
    computed: {
        complementaryCodificationsServices() {
            return complementaryCodificationsServices
        },
        COMPLEMENTARIES_TAB_INDEX() {
            return COMPLEMENTARIES_TAB_INDEX
        },
        CODIFICATIONS_TAB_INDEX() {
            return CODIFICATIONS_TAB_INDEX
        },
        OBSERVATIONS_TAB_INDEX() {
            return OBSERVATIONS_TAB_INDEX
        }
    },
    async mounted() {
        await this.loadComplementaries()
        this.$nextTick(() => {
            this.replaceClickOnTabEvents()
        })
    },
    methods: {
        onCardSelected(complementary) {
            if (!complementary) {
                this.selectCompCard(null)
            } else {
                this.checkChangesInActiveTabAndApplyAction(() => this.selectCompCard(complementary))
            }
        },
        async loadComplementaries() {
            await this.$refs.complementaryCards.loadComplementaries()
        },
        async loadDescriptionAudioAttachments() {
            await this.$refs.complementarySection.loadDescriptionAudioAttachments()
        },
        async getSectionsSummary() {
            if (this.complementarySelected) {
                const [err, response] = await this.toCall(commonComplementaryService.complementarySectionsSummary(this.labId, this.casId, this.complementarySelected.comId))
                if (err) {
                    this.showErrorModalGlobal()
                }
                this.sectionsSummary = response
            }
        },
        selectCompCard(complementary) {
            this.complementarySelected = complementary
            this.$nextTick(() => {
                this.replaceClickOnTabEvents()
            })
        },
        replaceClickOnTabEvents() {
            const tabs = document.getElementsByClassName('manuallyControlledTab')
            if (tabs.length === 0) {
                setTimeout(this.replaceClickOnTabEvents, 100)
                return
            }
            for (let i = 0; i < tabs.length; i++) {
                const tab = tabs.item(i)
                tab.addEventListener('click', this.navigateToTab)
            }
        },
        navigateToTab(mouseEvent) {
            const newTabIndex = Number.parseInt(mouseEvent.currentTarget.children[0].getAttribute('aria-posinset')) - 1
            this.checkChangesInActiveTabAndApplyAction(() => {
                this.tabIndexSelected = newTabIndex
            })
        },
        async checkChangesInActiveTabAndApplyAction(goToRoute, changedLaboratory) {
            const activeTabContent = this.getActiveTabContent()
            if (changedLaboratory) {
                if (!activeTabContent) {
                    await HelperUtils.runActionsWhenChangeLaboratory(goToRoute)
                    return
                }
                if (activeTabContent.hasBeenChanged()) {
                    this.$refs.unsavedChangesModal.askAndExecuteCallbacks(
                        activeTabContent.save,
                        async () => {
                            HelperUtils.runActionsWhenChangeLaboratory(goToRoute)
                        },
                        () => { router.currentRoute.meta.skipChecking = false }
                    )
                } else {
                    HelperUtils.runActionsWhenChangeLaboratory(goToRoute)
                }
            } else {
                if (!activeTabContent) {
                    goToRoute()
                    return
                }
                if (activeTabContent.hasBeenChanged()) {
                    this.$refs.unsavedChangesModal.askAndExecuteCallbacks(
                        () => { return activeTabContent.save() },
                        goToRoute)
                } else {
                    goToRoute()
                }
            }
        },
        async saveChangesInActiveTabAndApplyAction(actionIfTrue) {
            const activeTabContent = this.getActiveTabContent()
            if (!activeTabContent) {
                actionIfTrue()
                return
            }
            if (activeTabContent.hasBeenChanged()) {
                await activeTabContent.save()
                actionIfTrue()
            } else {
                actionIfTrue()
            }
        },
        getActiveTabContent() {
            if (this.tabIndexSelected === COMPLEMENTARIES_TAB_INDEX) {
                return this.$refs.complementarySection
            } else if (this.tabIndexSelected === CODIFICATIONS_TAB_INDEX) {
                return this.$refs.codificationsSection
            } else if (this.tabIndexSelected === OBSERVATIONS_TAB_INDEX) {
                return this.$refs.observationsSection
            } else {
                return null
            }
        }
    }
}
</script>

<style lang="scss">
    .complementaryDiagnosisView .manuallyControlledTab {
        cursor: pointer;
    }

    .complementaryDiagnosisView .manuallyControlledTab > a {
        pointer-events: none;
    }

    .complementaryDiagnosisView .comp-empty-state {
        background:linear-gradient(to top, rgba(196,196,196,0), rgba(196,196,196,.2));
        width: 100%;
        border-radius:2px;
    }

    .complementaryDiagnosisView .empty-state-layout {
        height: calc(100% - 100px);
    }

    .complementaryDiagnosisView .empty-state-layout h3 {
        font-size: font-size(very-big);
    }

    .complementaryDiagnosisView .empty-box {
        background: grey;
        border-radius: 5px;
        opacity: .2;
    }

    .complementaryDiagnosisView .empty-box.title {
        width: 200px;
        height: 20px;
    }

    .complementaryDiagnosisView .empty-box.button {
        width: 20px;
        height: 20px;
    }

    .complementaryDiagnosisView .empty-col {
        background:linear-gradient(to top, rgba(196,196,196,0), rgba(196,196,196,.2));
        width: 50px;
        margin-top:40px;
    }

    .complementaryDiagnosisView .empty-section {
        background: grey;
        width: 50px;
        height: 40px
    }

    .complementaryDiagnosisView .picture{
        position:relative;
        height: 150px;
        width: 150px;
    }

    .complementaryDiagnosisView .picture img{
        position:relative;
        z-index: 1;
        width: 150px;
    }

    .complementaryDiagnosisView .picture .circle {
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
        background: vt-color(primary);
        opacity: .2;
        border-radius: 50%;
        z-index: 0;
    }

</style>
